
<template>
  <div>
    <Tabs type="card" class="tabs-style">
      <TabPane label="常规书型盒">
      <Form :label-width="110" class="aaa">
        <FormItem label="成品尺寸">
          <Row>
            <Col span="3">
              <Input v-model.number="long" placeholder="长"></Input>
            </Col>
            <Col span="1" style="text-align: center">X</Col>
            <Col span="3">
            <Input v-model.number="wide" placeholder="宽"></Input>
            </Col>
            <Col span="1" style="text-align: center">X</Col>
            <Col span="3">
            <Input v-model.number="height" placeholder="高"></Input>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="数量">
          <Input v-model.number="quantity" style="width:200px"></Input>
        </FormItem>
        <Card style="width:800px">
          <p slot="title" >
            皮壳信息
          </p>
          <FormItem label="纸板材料">
            <Select v-model="cardboard" style="width:200px">
              <Option v-for="item in this.cardboards" :value="item.value" :key="item.value">{{ item.value }}</Option>
            </Select>&nbsp;&nbsp;
            <Select v-model="thick" style="width:200px">
              <Option v-for="item in this.thicks" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="面纸材料">
            <Select v-model="paper" style="width:200px">
              <Option v-for="item in this.papers" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>&nbsp;&nbsp;
            <Select v-model="print" style="width:200px">
              <Option v-for="item in this.prints" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>&nbsp;&nbsp;
          </FormItem>
          <FormItem label="面纸工艺">
            <Checkbox v-model="isUV">UV上光</Checkbox>
            <Checkbox v-model="ispermed">烫工艺</Checkbox>
          </FormItem>
          <FormItem label="内贴材料">
            <Select v-model="StickerPaper" style="width:200px">
              <Option v-for="item in this.papers" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>&nbsp;&nbsp;
            <Select v-model="stickerPrint" style="width:200px">
              <Option v-for="item in this.prints" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="内贴工艺">
            <Checkbox v-model="isStickerUV">UV上光</Checkbox>
            <Checkbox v-model="isStickerPermed">烫工艺</Checkbox>
          </FormItem>
        </Card>
        <Card style="width:800px">
          <p slot="title">内盒</p>
          <FormItem label="纸板材料">
            <Select v-model="outerCardboard" style="width:200px">
              <Option v-for="item in this.cardboards" :value="item.value" :key="item.value">{{ item.value }}</Option>
            </Select>&nbsp;&nbsp;
            <Select v-model="outerThick" style="width:200px">
              <Option v-for="item in this.thicks" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="内盒材料">
            <Select v-model="outerPaper" style="width:200px">
              <Option v-for="item in this.papers" :value="item.value" :key="item.value">{{ item.value }}</Option>
            </Select>&nbsp;&nbsp;
            <Select v-model="outerPrint" style="width:200px">
              <Option v-for="item in this.prints" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="内托材料">
            <Checkbox v-model="isMaterial">内托</Checkbox>
            <span v-if="isMaterial">
              <Select v-model="material" style="width:200px">
                <Option value="珍珠棉">珍珠棉</Option>
                <Option value="PE">PE</Option>
                <Option value="海绵">海绵</Option>
                <Option value="EVA">EVA</Option>
              </Select>&nbsp;&nbsp;
              厚度:&nbsp;&nbsp;<Input @on-change="setMaterialHeight" v-model.number="materialHeight" style="width: 50px" />&nbsp;&nbsp;mm&nbsp;&nbsp;
              <RadioGroup v-model="isFlock">
                <Radio label="1">加绒布</Radio>
                <Radio label="2">加绸布</Radio>
              </RadioGroup>
            </span>
          </FormItem>
          <FormItem label="包边方式">
            <RadioGroup v-model="bottomCurlingType">
              <Radio label="1">正常包边15mm</Radio>
              <Radio label="2" :disabled="!isMaterial">包边至内托以下5MM</Radio>
              <Radio label="3">自定义</Radio>
            </RadioGroup>
            <span v-if="bottomCurlingType==='3'">
              包边:&nbsp;&nbsp;<Input v-model.number="bottomCurling" style="width: 50px" />&nbsp;&nbsp;mm&nbsp;&nbsp;
              <Checkbox v-model="isBottomPaste">裱底贴</Checkbox>
            </span>
          </FormItem>      
        </Card>
        <FormItem>
          <Button type="primary" @click.native="CountPrice">报价</Button>
          <Button style="margin-left: 8px">清空</Button>
        </FormItem>
      </Form>
      <Card style="margin-top:5px">
        <p slot="title">报价结果</p>
        <p v-if="boxPrice.count !== 0">{{boxPrice.count}} 元</p>
      </Card>
      </TabPane>
    </Tabs>

  </div>
</template>
<script>
import selectData from '@/data/selectData'
import CountPriceJs from '@/lib/CountPrice.js'
export default {
  data () {
    return {
      // 成品要求与尺寸
      long: 300, // 礼盒外空-长
      wide: 200, // 礼盒外空-宽
      height: 50, // 礼盒外空-高
      quantity: '1000', // 数量
      // 皮壳信息
      isUV: false, // 是否UV
      ispermed: false,
      paper: '铜版纸', // 皮壳包纸用料
      print: 1, // 皮壳包纸印刷
      cardboard: '双灰板', // 皮壳纸板用料
      thick: 2, // 皮壳纸板厚度
      // 内贴信息
      isStickerUV: false,
      isStickerPermed: false,
      StickerPaper: '铜版纸', // 内贴纸用料
      stickerPrint: 4, // 内贴纸印刷选项
      // 底盒信息
      outerPaper: '铜版纸', // 内盒包纸用料
      outerPrint: 4, // 内盒印刷
      outerCardboard: '裱白板',
      outerThick: 2,
      bottomCurlingType: '1', // 底盒 包边类型
      bottomCurling: 15,
      isBottomPaste: true, // 底盒 是否裱内贴
      // 内托
      isMaterial: false, // 有无内托
      material: '珍珠棉',
      materialHeight: '',
      isFlock: '1',
      // 合计报价对象
      boxPrice: {
        count: 0, // 总价
        hullPage: 0, // 皮壳包纸
        boxOuterPage: 0, // 内盒包纸
        sticker: 0, // 内贴包纸
        hullCardboard: 0, // 皮壳纸板
        boxOuterCardboard: 0, // 内盒纸板
        process: 0, // 加工费
        carton: 0, // 纸箱
        material: 0, // 内托
      }
    }
  },
  mixins: [selectData],
  computed: {
    // 皮壳纸板-展开尺寸
    HullBoard: function () {
      const HullBoard = {
        'long': this.wide * 2 + this.height * 2 ,
        'wide': this.long 
      }
      return HullBoard
    },
    // 皮壳包纸-展开尺寸
    HullColorSurface: function () {
      const HullColorSurface = {
        'long': (this.wide + this.height) * 2 + 40,
        'wide': this.long + 40 
      }
      return HullColorSurface
    },
    // 内盒纸板-展开尺寸
    BoxOuterBoard: function () {
      const BoxOuterBoard = {
        'long': this.long + this.height * 2,
        'wide': this.wide + this.height * 2 
      }
      return BoxOuterBoard
    },
    // 内盒包纸-展开尺寸
    BoxOuterColorSurface: function () {
      const BoxOuterColorSurface = {
        'long': this.long + this.height * 2 + this.bottomCurling *2 + this.thick * 2,
        'wide': this.wide + this.height * 2 + this.bottomCurling *2 + this.thick * 2
      }
      return BoxOuterColorSurface
    },
    // 皮壳内贴
    Sticker: function () {
      const Sticker = {
        'long': this.long,
        'wide': this.height + this.wide + 20 
      }
      return Sticker
    },
  },
  watch: {
    bottomCurlingType: function (newQuestion) {
      this.bottomCurling = newQuestion === '1' ? 15 : this.height + 5 - this.materialHeight
    }
  },
  methods: {
    // 勾选内托下方5mm 则根据输入变化的内托高度调整尺寸
    setMaterialHeight: function () {
      if (this.bottomCurlingType === '2') {
        this.bottomCurling = this.height + 5 - this.materialHeight
      }
    },
    CountPrice: function () {
      // 清空上次计算数据
      for (var i in this.boxPrice) {
        this.boxPrice[i] = 0
      }
      const boxName = this.long < 250 ? '书型盒(小)' : this.long > 350 ? '书型盒(大)' : '书型盒(中)'
      CountPriceJs.getPrices().then(() => {
        // 加工费
        this.boxPrice.process = CountPriceJs.ProcessPromise(boxName, this.quantity, this.height)
        // 皮壳纸板
        this.boxPrice.hullCardboard = CountPriceJs.CardboardPromise(this.HullBoard.long, this.HullBoard.wide, this.cardboard, this.thick)
        // 皮壳包纸
        this.boxPrice.hullPage = CountPriceJs.Print(this.HullColorSurface.long, this.HullColorSurface.wide, this.quantity, this.print, this.paper, 157)
        // 皮壳面彩-工艺
        if (this.ispermed) { // 烫金
          this.boxPrice.hullPage +=  CountPriceJs.Permed(this.quantity)
        }
        if (this.isUV) { // UV
          this.boxPrice.hullPage +=  CountPriceJs.UV(this.quantity)
        }
        // 内盒纸板
        this.boxPrice.boxOuterCardboard = CountPriceJs.CardboardPromise(this.BoxOuterBoard.long, this.BoxOuterBoard.wide, this.outerCardboard, this.outerThick)
        // 内盒包纸
        this.boxPrice.boxOuterPage = CountPriceJs.Print(this.BoxOuterColorSurface.long, this.BoxOuterColorSurface.wide, this.quantity, this.outerPrint, this.outerPaper, 157)
        // 内盒内贴
        if (this.isBottomPaste && this.bottomCurlingType === '3') {
          this.boxPrice.boxOuterPage += CountPriceJs.Print(this.long, this.wide, this.quantity, 4, this.outerPaper, 157) + 0.2
        }
        // 内贴包纸
        this.boxPrice.sticker = CountPriceJs.Print(this.Sticker.long, this.Sticker.wide, this.quantity, this.stickerPrint, this.StickerPaper, 157) 
        // 内贴-工艺
        if (this.isStickerPermed) { // 烫金
          this.boxPrice.boxOuterPage +=  CountPriceJs.Permed(this.quantity)
        }
        if (this.isStickerUV) { // UV
          this.boxPrice.boxOuterPage +=  CountPriceJs.UV(this.quantity)
        }
        // 内托成本计算
        if (this.isMaterial) {
          const square = (this.long * 0.001) * (this.wide * 0.001)
          this.boxPrice.material = CountPriceJs.EPE(this.long, this.wide, this.materialHeight, this.material)
          this.boxPrice.material += this.isFlock === '1' ? square * 10 : CountPriceJs.Drapery(this.long * 1.5, this.wide* 1.5, '高档绸布')
        }
        // 纸箱价格
        this.boxPrice.carton = CountPriceJs.Carton(this.long, this.wide, this.height)
      }).then(() => {
        // 自动计算总价
        for (var i in this.boxPrice) {
          this.boxPrice.count += i === 'count' ? 0 : Number(this.boxPrice[i])
          console.log(`${i}:${this.boxPrice[i].toFixed(2)}`)
        }
        this.boxPrice.count = (this.boxPrice.count * 1.05).toFixed(2)
      }).catch(value => console.log(value))
    }
  }
}
</script>
